module.exports = __webpack_public_path__ + "static/img/67066G_C_03_20170813_fit.64ff11e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/67066G_C_03_20170813_fit.png
// module id = 12hW
// module chunks = 0